/**
 * MISSION CONTROL ENGINE V4.0 - SOVEREIGN SINGLETON
 * The single source of truth for the entire mission builder state.
 * This script must be loaded once in theme.liquid.
 */
if (typeof window.MissionControl === 'undefined') {
  window.MissionControl = (function() {
    // The canonical state object. This is the single source of truth.
    const state = {
      currentPhase: 1,
      totalPrice: 0, // Stored in cents
      totalQty: 0,
      design: {
        artwork: null,
        identity: {},
        logoColors: [],
        itemColors: []
      },
      kit: {} // Keyed by row ID
    };

    // Private method to load state from localStorage with fault tolerance.
    const _loadState = () => {
      try {
        const savedState = localStorage.getItem('void_mission_state');
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          // Merge saved state into the default structure to ensure all keys exist.
          Object.assign(state, parsedState);
          console.log('MissionControl: Neural state restored from persistence layer.');
        }
      } catch (error) {
        console.error('MissionControl: Catastrophic failure in state deserialization. Purging corrupted state.', error);
        localStorage.removeItem('void_mission_state');
      }
    };

    // Private method to save state.
    const _saveState = () => {
      localStorage.setItem('void_mission_state', JSON.stringify(state));
    };

    // Private method to broadcast state changes to all subscribers.
    const _broadcast = () => {
      document.dispatchEvent(new CustomEvent('missionControl:update', {
        detail: { state: JSON.parse(JSON.stringify(state)) } // Deep copy for safety
      }));
    };

    // Public API
    const publicAPI = {
      /**
       * Initializes the state machine and broadcasts its readiness.
       */
      init: function() {
        _loadState();
        console.log('MissionControl: System Online. Broadcasting readiness signal.');
        // Broadcast readiness to all listening components.
        document.dispatchEvent(new CustomEvent('missionControl:ready', {
          detail: { state: JSON.parse(JSON.stringify(state)) }
        }));
      },

      /**
       * Updates the state by merging a new state object.
       * @param {object} newState - The partial state object to merge.
       */
      updateState: function(newState) {
        Object.assign(state, newState);
        _saveState();
        _broadcast();
      },

      /**
       * Returns a safe, deep copy of the current state.
       */
      getState: function() {
        return JSON.parse(JSON.stringify(state));
      }
    };

    return publicAPI;
  })();

  // Auto-initialize the system as soon as this script is executed.
  window.MissionControl.init();
}